import React from 'react';
import bn from '../utils/bemnames';

const bem = bn.create('loading-spinner');

const LoadingSpinner = () => (
  <div className={bem.e('wrp')}>
    <div className={bem.e('ring')} />
  </div>
);

export default LoadingSpinner;
